'use client'

import { Box, Text, VStack, AspectRatio } from '@chakra-ui/react'
import { FC } from 'react'
import { StaticImageData } from 'next/image'
import Link from 'next/link'
import { GrandImage } from 'ui'

export type LogoCardProps = {
  name: string
  category: string
  logoUrl?: string | StaticImageData
  href?: string
}

export const LogoCard: FC<LogoCardProps> = ({ name, category, logoUrl, href }) => {
  const cardContent = (
    <Box
      bg="background.default"
      border="1px solid"
      borderColor="border.default"
      borderRadius="card"
      p={{ base: 4, md: 6 }}
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      textAlign="center"
      minH="120px"
      transition="all 0.2s ease"
      cursor={href ? 'pointer' : 'default'}
      _hover={{
        borderColor: 'teal.500',
        boxShadow: '0 4px 12px rgba(27, 133, 145, 0.08)',
        transform: 'translateY(-2px)'
      }}
    >
      <VStack gap={4} w="100%">
        {logoUrl ? (
          <AspectRatio
            ratio={10 / 3}
            display="flex"
            alignItems="center"
            justifyContent="center"
            w="100%"
            maxH="50px"
          >
            <GrandImage
              src={logoUrl}
              alt={name}
              maxWidth="100%"
              sx={{
                objectFit: 'contain!important'
              }}
            />
          </AspectRatio>
        ) : (
          <Text fontWeight={600} fontSize="1.1rem" letterSpacing="-0.01em" color="text.default">
            {name}
          </Text>
        )}
        <Text fontSize="0.75rem" color="text.secondary">
          {category}
        </Text>
      </VStack>
    </Box>
  )

  if (href) {
    return <Link href={href}>{cardContent}</Link>
  }

  return cardContent
}
